import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import RecapItem from 'components/Content/Recap/RecapItem';
import { Image } from 'components/ui';

function RecapReplenishment({ replenishmentData, isLoading, localization, ...props }) {
    const { skuImageUrl, servedSkuNumber } = replenishmentData || {};
    const showImage = !isLoading && skuImageUrl;

    return (
        <RecapItem
            {...props}
            isLoading={isLoading}
            isSingleImage={true}
        >
            {showImage && (
                <Image
                    src={skuImageUrl}
                    alt={`${localization.productImage} ${servedSkuNumber || ''}`}
                    width={['100%']}
                />
            )}
        </RecapItem>
    );
}

RecapReplenishment.propTypes = {
    replenishmentData: PropTypes.shape({
        context: PropTypes.string,
        servedSkuNumber: PropTypes.string,
        skuImageUrl: PropTypes.string,
        isControl: PropTypes.bool,
        isAbTest: PropTypes.bool,
        isDefault: PropTypes.bool
    }),
    isLoading: PropTypes.bool,
    localization: PropTypes.object
};

export default wrapFunctionalComponent(RecapReplenishment, 'RecapReplenishment');
